export default [
    {
        // ログイン
        path: '/',
        component: () => import('./pages/Login.vue')
    },
    {
        // トップ
        path: '/top',
        name: 'top',
        component: () => import('./pages/Top.vue'),
        meta: {
            requiresAuth: true
        }
    },
    /********************************************************
     * 対戦データ
     *******************************************************/
    {
        // 対戦データ解析 選手リスト
        path: '/vsDataList/:teamID?',
        name : 'vsDataList',
        component: () => import('./pages/VsDataList.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        // 対戦データ解析
        path: '/vsData/:teamID?/:playerID?',
        name : 'vsData',
        component: () => import('./pages/VsData.vue'),
        meta: {
            requiresAuth: true
        }
    },
    /********************************************************
     * 投手データ
     *******************************************************/
    {
        // 投手データ解析 選手リスト
        path: '/pitchingData/:teamID?/List/',
        name : 'pitchingData.List',
        component: () => import('./pages/PitchingDataList.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        // 投手データ解析 全投球サマリー
        path: '/pitchingData/:teamID?/:playerID?/:gameID?/Summary',
        name : 'pitchingData.Summary',
        component: () => import('./pages/PitchingDataSummary.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        // 投手データ解析 リリースポジション 投手側から
        path: '/pitchingData/:teamID?/:playerID?/:gameID?/ReleasePosition',
        name : 'pitchingData.ReleasePosition',
        component: () => import('./pages/PitchingDataReleasePosition.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        // 投手データ解析 過去データ
        path: '/pitchingData/:teamID?/:playerID?/:gameID?/Past',
        name : 'pitchingData.Past',
        component: () => import('./pages/PitchingDataPast.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        // 投手データ解析 スピード
        path: '/pitchingData/:teamID?/:playerID?/:gameID?/Speed',
        name : 'pitchingData.Speed',
        component: () => import('./pages/PitchingDataSpeed.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        // 投手データ解析 スピンレート
        path: '/pitchingData/:teamID?/:playerID?/:gameID?/Spin',
        name : 'pitchingData.Spin',
        component: () => import('./pages/PitchingDataSpin.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        // 投手データ解析 リリース（高さ）
        path: '/pitchingData/:teamID?/:playerID?/:gameID?/ReleaseHeight',
        name : 'pitchingData.ReleaseHeight',
        component: () => import('./pages/PitchingDataReleaseHeight.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        // 投手データ解析 リリース（横幅）
        path: '/pitchingData/:teamID?/:playerID?/:gameID?/ReleaseWidth',
        name : 'pitchingData.ReleaseWidth',
        component: () => import('./pages/PitchingDataReleaseWidth.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        // 投手データ解析 リリース（長さ）
        path: '/pitchingData/:teamID?/:playerID?/:gameID?/ReleaseLength',
        name : 'pitchingData.ReleaseLength',
        component: () => import('./pages/PitchingDataReleaseLength.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        // 投手データ解析 垂直変化
        path: '/pitchingData/:teamID?/:playerID?/:gameID?/Vertical',
        name : 'pitchingData.Vertical',
        component: () => import('./pages/PitchingDataVertical.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        // 投手データ解析 水平変化
        path: '/pitchingData/:teamID?/:playerID?/:gameID?/Horizontal',
        name : 'pitchingData.Horizontal',
        component: () => import('./pages/PitchingDataHorizontal.vue'),
        meta: {
            requiresAuth: true
        }
    },
    /********************************************************
     * 打者データ解析
     *******************************************************/
    {
        // 打者データ解析 選手リスト
        path: '/battingDataList/:teamID?',
        name : 'battingDataList',
        component: () => import('./pages/BattingDataList.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        // 対戦データ解析
        path: '/battingData/:teamID?/:playerID?/:tabType?/:secondTabType?',
        name : 'battingData',
        component: () => import('./pages/BattingData.vue'),
        meta: {
            requiresAuth: true
        }
    },
    /********************************************************
     * チェックリスト
     *******************************************************/
    {
        // チェックリスト
        path: '/checkList',
        component: () => import('./pages/CheckList.vue'),
        meta: {
            requiresAuth: true
        }
    },
    /********************************************************
     * 3D軌跡
     *******************************************************/
    {
        // 3D軌跡
        path: '/three/:ball?',
        name : 'three',
        component: () => import('./pages/Three'),
        meta: {
            requiresAuth: true
        }
    },
    /********************************************************
     * HE
     *******************************************************/
    {
        path: '/HawkEyePitching/:teamID?',
        name: 'HawkEyePitching',
        component: () => import('./pages/HE/HEPitching.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/HawkEyeBatting/:teamID?',
        name: 'HawkEyeBatting',
        component: () => import('./pages/HE/HEBatting.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/he/pitchingDataSummary/:teamID?/:playerID?/:gameID?',
        name : 'he.pitchingDataSummary',
        component: () => import('./pages/HE/PitchingDataSummary.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/he/pitchingCenterVelocity/:teamID?/:playerID?/:gameID?',
        name : 'he.pitchingCenterVelocity',
        component: () => import('./pages/HE/PitchingCenterVelocity.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/he/pitchingVarusTorque/:teamID?/:playerID?/:gameID?',
        name : 'he.pitchingVarusTorque',
        component: () => import('./pages/HE/PitchingVarusTorque.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/he/pitchingEnergyAmount/:teamID?/:playerID?/:gameID?',
        name : 'he.pitchingEnergyAmount',
        component: () => import('./pages/HE/PitchingEnergy.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/he/pitchingEnergyTransfer/:teamID?/:playerID?/:gameID?',
        name : 'he.pitchingEnergyTransfer',
        component: () => import('./pages/HE/PitchingEnergyTransfer.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        // 投手データ解析 過去データ
        path: '/he/pitchingDataPast/:teamID?/:playerID?/:gameID?',
        name : 'he.pitchingDataPast',
        component: () => import('./pages/HE/PitchingDataPast.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        // 対戦データ解析
        path: '/he/battingData/:teamID?/:playerID?/:tabType?',
        name : 'he.battingData',
        component: () => import('./pages/HE/BattingData.vue'),
        meta: {
            requiresAuth: true
        }
    },
    /********************************************************
     * VIDEO
     *******************************************************/
    {
        // 対戦データ解析
        path: '/videoList',
        name : 'videoList',
        component: () => import('./pages/VideoList.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        // 対戦データ解析
        name: 'VideoPlayer',
        path: '/videoPlayer/:id',
        component: () => import('./pages/VideoPlayer.vue'),
        meta: {
            requiresAuth: true
        }
    },
    /********************************************************
     * ピッチトンネル
     *******************************************************/
    {
        path: '/PitchiTunnelSearch',
        name: 'PitchiTunnelSearch',
        component: () => import('./pages/PitchiTunnelSearch'),
        meta:{
            requiresAuth:true
        }
    },{
        path: '/pitchiTunnelBallConf',
        name: 'pitchiTunnelBallConf',
        component: () => import('./pages/PitchiTunnelBallConf'),
        meta:{
            requiresAuth:true
        }
    },{
        path: '/pitchiTunnelChangeSelect',
        name: 'pitchiTunnelChangeSelect',
        component: () => import('./pages/PitchiTunnelChangeSelect'),
        meta:{
            requiresAuth:true
        }
    },{
        path: '/pitchiTunnelChangeSelectEx',
        name: 'pitchiTunnelChangeSelectEx',
        component: () => import('./pages/PitchiTunnelChangeSelectEx'),
        meta:{
            requiresAuth:true
        }
    },{
        path: '/pitchiTunnelThresholdSelect',
        name: 'pitchiTunnelThresholdSelect',
        component: () => import('./pages/PitchiTunnelThresholdSelect'),
        meta:{
            requiresAuth:true
        }
    },{
        path: '/pitchiTunnelThresholdSelectEx',
        name: 'pitchiTunnelThresholdSelectEx',
        component: () => import('./pages/PitchiTunnelThresholdSelectEx'),
        meta:{
            requiresAuth:true
        }
    },
    /********************************************************
     * チェックリスト
     *******************************************************/
    {
        // チェックリスト
        path: '/ranking/:teamID?/:year?/:type?',
        name: 'ranking',
        component: () => import('./pages/Ranking.vue'),
        meta: {
            requiresAuth: true
        }
    },
    /********************************************************
     * チェックリスト
     *******************************************************/
    {
        // チェックリスト
        path: '/alert/:teamID?/:year?',
        name: "alert",
        component: () => import('./pages/Alert.vue'),
        meta: {
            requiresAuth: true
        }
    },
    /********************************************************
     * MatchUp
     *******************************************************/
    {
        path: '/MatchUpPitching/:teamID?',
        name: 'MatchUpPitching',
        component: () => import('./pages/MatchUp/MatchUpPitching.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/MatchUpBatting/:teamID?',
        name: 'MatchUpBatting',
        component: () => import('./pages/MatchUp/MatchUpBatting.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/MatchUp/:type?/:teamID?/:playerID?',
        name : 'MatchUp',
        component: () => import('./pages/MatchUp/MatchUp.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path : '/bone3d/:ballId?',
        name : "bone3d",
        component: () => import('./pages/Bone3D.vue'),
        meta : {
            requiresAuth: true
        }
    }
]
